/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_LanguageInputs */

const en_idea_language = /** @type {(inputs: Idea_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document language`)
};

const id_idea_language = /** @type {(inputs: Idea_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa dokumen`)
};

/**
* | output |
* | --- |
* | "Document language" |
*
* @param {Idea_LanguageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_language = /** @type {((inputs?: Idea_LanguageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_LanguageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_language(inputs)
	return en_idea_language(inputs)
});